// removed by extract-text-webpack-plugin
module.exports = {"selectWrapper":"_34NNK","typeBasic":"CjxPj","transparentBackground":"_3Nl1x","typeMulti":"_213fX","sizeMedium":"_2MrHc","sizeSmall":"_2ffby","kindLight":"_3_GSu","kindDark":"_3jGS_","kindTransparent":"_2eyHW","is-focused":"U9eQs","is-open":"_2cBQs","Select-control":"_3m06r","label":"_13iko"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Select/Select.css
// module id = 521
// module chunks = 0